import { LightbulbSpotOffIcon } from './LightbulbSpotOffIcon';

/**
 * author: Michael Irigoyen
 * id A4DF4624-753B-440B-98C9-A25EE330B0AE
 * name lightbulb-spot-off
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/lightbulb-spot-off.svg
 * tags
 * - Home Automation 
 */
export const LightbulbHalogenOffIcon = LightbulbSpotOffIcon;
export default LightbulbHalogenOffIcon